/**
 * Hack which may be solve IE problems, because VUE JS not compatible with IE
 */
import 'babel-polyfill';
/**
 * Validators
 */
import Vuelidate from 'vuelidate';
/**
 * Global Variables via mixin
 */
import CONSTANTS from './constants';
/**
 * Global store
 */
import store from './store';
/**
 * App routes
 */
import router from './routes';
/**
 * Toasted messages
 */
import Toasted from 'vue-toasted';

import VueLazyLoad from 'vue-lazyload'

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');
Vue.use(Vuelidate);
Vue.use(Toasted, {
    duration: 5000
});
Vue.use(VueLazyLoad);

/**
 * init events bus
 */
const EventBus = new Vue();

Vue.mixin({
    data() {
        return {
            get CONSTANTS() {
                return CONSTANTS;
            },
            get EventBus() {
                return EventBus;
            },
            beforeRedirectTimeOut: 1000,
            isFormPending: false
        }
    },
    methods: {
        inputStatus(validation, key) {
            return {
                'is-invalid': (validation[key].$error || this.$store.getters['formErrors/hasErrors'](key)),
                'is-dirty': validation[key].$dirty
            }
        },
        routerBack() {
            this.$router.go(-1)
        },
    }
});

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.component('form-error', require('./components/form-error.vue'));
Vue.component('contact-us', require('./components/contact-us.vue'));

const app = new Vue({
    el: '#app',
    store,
    router
});



// WEBPACK FOOTER //
// ./resources/js/app.js